import styled from "styled-components"

import {TextButton} from "@irati/ui/src/Button"
import {TROPHY_SIZE, PADDING} from "../constants"

const StyledButton = styled(TextButton)`
  box-shadow: none;
  position: relative;
  padding: ${PADDING}px;
  width: ${TROPHY_SIZE}px;
  height: ${TROPHY_SIZE}px;
  text-align: center;
  :active {
    padding: ${PADDING}px;
    padding-bottom: ${PADDING + 1}px;
  }
`

export default StyledButton
